<template>
    <div class="lottery_index" v-loading="loading"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="page_top">
            <div class="title" @click="goHome()"><i class="icon"></i>發文抽獎</div>
        </div>
        <div class="page_padding" >
            <img class="lottery_img" src="~@/assets/lottery/lottery_background.jpg" alt="">
            <el-row type="flex" justify="center">
                <el-badge :value="this.memberLotteyCount" class="item" style="margin: 30px">
                    <el-button type="warning" icon="el-icon-present" @click="lottery()" round style="font-size: 2rem"
                               :disabled="!this.canDoLottery">開始抽獎
                    </el-button>
                </el-badge>
            </el-row>
            <el-row style="margin-left:10px">
                <el-tag type="success" effect="dark"  class="content_title" >領獎辦法</el-tag>
                <p class="focus">請於下方【<i class="el-icon-setting"></i>個人設定】 <i class="el-icon-right"></i>【<i class="el-icon-present">我的獎品</i>】查看使用</p>
                <el-tag type="success" effect="dark"  class="content_title">活動規則</el-tag>
                <p class="focus">
                    1.凡活動期間內會員在鹿路APP內完成發文投稿任一項功能(運輸媒合、司機徵才、物件買賣)，即享有一次抽獎的資格。
                </p>
                <p>
                    2.會員在鹿路APP內發文投稿，發文內容不得重複，且文字敘述需(含)15字以上。
                </p>
                <p>
                    3.會員在鹿路APP內發文投稿期間，發文超過5篇以上，公司將會進行內部審查，查看發文內容是否有重複，且審查期間內會員將暫停抽獎資格，若經公司內部審查後發現會員發文有重複，公司有權利取消會員抽獎活動資格。
                </p>
                <p class="focus">
                    4.在此活動中Apple不是贊助者，也沒有以任何形式參與活動
                </p>

                <el-tag type="success" effect="dark"  class="content_title">活動時間</el-tag>
                <p>即日起~獎品抽完為止。</p>

                <el-tag type="success" effect="dark"  class="content_title">活動對象</el-tag>
                <p>凡是鹿路APP裡的會員，皆享有抽獎資格。
                </p>

                <el-tag type="success" effect="dark"  class="content_title">注意事項</el-tag>
                <p>會員於參加本抽獎活動同時，即同意接受鹿路APP相關活動規則與注意事項。
                </p>
                <p>獎品數量有限，若獎品全數兌換完畢，本抽獎活動將暫停結束。
                </p>
                <p>本公司保有所有相關活動最終解釋權及活動更改之權利。</p>
            </el-row>


        </div>
        <MENU/>
        <el-backtop target=".page_padding" :bottom="150" style="opacity: 0.7"></el-backtop>
    </div>
</template>
<script>
    import FN from '@/components/fn'
    import MENU from '@/components/menu.vue'
    import {mapActions} from 'vuex'

    export default {
        components: {
            MENU
        },
        mixins: [FN],
        data() {
            return {
                haveManyGift: false,
                canDoLottery: false,
                memberLotteyCount: 0,
                loading: true
            }
        },
        mounted() {
            this.lotteryGiftAmount();
            this.memberLotteryAmount();
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            lottery() {
                this.canDoLottery = false;
                this.loading = true;
                this.FETCH({
                    key: 'LOTTERY_DO',
                    lotteryId: '1'
                }).then((res) => {
                    this.loading = false;
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            handleResponse(res) {
                if (!+res.code) {
                    var type= 'info'
                    var message = '您未中獎。'
                    if(res.data.isShow == 1){
                        type= 'success'
                        message ='恭喜中獎，【'+res.data.name+'】'
                    }
                    this.$confirm(message, {
                        showCancelButton: false,
                        type: type
                    })
                        .then(() => {
                            console.log(res);
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.lotteryGiftAmount();
                this.memberLotteryAmount();
                this.loading = false
            },
            lotteryGiftAmount() {
                this.haveManyGift = false;
                this.FETCH({
                    key: 'LOTTERY_GIFT_AMOUNT',
                    lotteryId: '1'
                }).then((res) => {
                    this.loading = false
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        if (res.data.amount > 0) {
                            this.haveManyGift = true;
                            if (this.memberLotteyCount > 0 && this.haveManyGift) {
                                this.canDoLottery = true;
                            }else {
                                this.canDoLottery = false;
                            }
                        } else {
                            this.$alert('目前獎項均已抽出，感謝您的參與', '活動已結束', {
                                confirmButtonText: '確定',
                            });
                        }

                    }
                })
            },
            memberLotteryAmount() {
                this.FETCH({
                    key: 'MEMBER_LOTTERY_AMOUNT',
                    lotteryId: '1'
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        if (res.data.amount > 0 && this.haveManyGift) {
                            this.canDoLottery = true;
                        }else {
                            this.canDoLottery = false;
                        }
                        this.memberLotteyCount = res.data.amount;

                    }
                })
            },

        }
    }
</script>
